<script>
    import NumberPicker from '../shared/NumberPicker.vue';
    import NavigationHeader from '../NavigationHeader';
    import EmailConfiguration from './EmailConfiguration';
    import {loadItem} from '@/services/Storage';
    import ButtonNormal from '@/components/buttons/ButtonNormal.vue';

    import PhonenumberService from '@/services/PhonenumberService';
    import ConferenceService from '@/services/ConferenceService';
    import {required} from 'vuelidate/lib/validators';

    const USER_DEFINED_LANGUAGE = 'userDefined';

    export default {
        name: 'Conference',
        components: {
            NumberPicker,
            NavigationHeader,
            EmailConfiguration,
            ButtonNormal,
        },
        data() {
            return {
                externalNumbers: [],
                selectedNumber: null,
                defaultValues: {
                    userDefined: {
                        eMailSubject: '',
                        eMailBody: '',
                    },
                },
                data: {
                    internalNumberId: null,
                    externalNumberId: null,
                    serverAddress: '',
                    eMailSubject: '',
                    eMailBody: '',
                    language: '',
                    variables: [],
                },
                variables: [// todo remove this property when data.variables will be returned from /defaults rest call
                    {name: 'Uhrzeit', placeholder: '%TIME%'},
                    {name: 'Datum', placeholder: '%DATE%'},
                    {name: 'PIN', placeholder: '%PIN%'},
                    {name: 'Konferenzname', placeholder: '%CONFERENCE_NAME%'},
                    {name: 'Name des Teilnehmers', placeholder: '%PARTICIPANT_NAME%'},
                    {name: 'Externe Rufnummer', placeholder: '%PHONE_EXTERNAL%'},
                    {name: 'Weblink', placeholder: '%WEB_LINK%'},
                    {name: 'Interne Rufnummer', placeholder: '%PHONE_INTERNAL%'},
                    {name: 'STARFACE ruft an', placeholder: '%CALL_PARTICIPANT_INFO%'},
                ],
                variablesToRemove: [
                    '%WEB_LINK%',
                ],
                isSubmitted: false,
            };
        },
        validations: {
            data: {
                eMailBody: {
                    required,
                },
                eMailSubject: {
                    required,
                },
            },
        },
        created() {
            ConferenceService.getConfiguration().then((response) => {
                if (!response.data.serverAddress) {
                    response.data.serverAddress = 'https://' + loadItem('serverUrl');
                }
                if (!response.data.language) {
                    response.data.language = 'de';
                }
                this.setupLanguage(response.data).then(() => {
                    this.data = Object.assign({}, response.data);
                    this.setupNumbers();
                });
            });
        },
        methods: {
            setupLanguage(data) {
                return this.retrieveDefaultValue(data.language).then(defaultData => {
                    if (data.eMailBody !== '' && this.$sanitize(defaultData.eMailBody) !== this.$sanitize(data.eMailBody)) {
                        data.language = USER_DEFINED_LANGUAGE;
                        this.defaultValues.userDefined = {eMailBody: data.eMailBody, eMailSubject: data.eMailSubject};
                    }

                    if (!data.eMailBody) {
                        data.eMailBody = defaultData.eMailBody;
                    }
                });
            },
            setupNumbers() {
                PhonenumberService.getAllPhonenumbers().then(
                    responsePhonenumbers => {
                        const {
                            external,
                            internalPhoneNumberId,
                        } = PhonenumberService.splitAndSortNumbers(
                            responsePhonenumbers.data,
                            this.data.internalNumberId,
                        );
                        this.externalNumbers = external;
                        this.data.internalNumberId = internalPhoneNumberId;
                        for (const phonenumber of this.externalNumbers) {
                            if (phonenumber.id === this.data.externalNumberId) {
                                phonenumber.available = true;
                                this.selectedNumber = phonenumber;
                                break;
                            }
                        }
                        if (this.selectedNumber === null) {
                            this.selectedNumber = {};
                        }
                    },
                );
            },
            retrieveData() {
                this.data.externalNumberId = this.selectedNumber.id;
                const data = Object.assign({}, this.data);
                if (data.language === USER_DEFINED_LANGUAGE) {
                    data.language = 'de';
                }
                return data;
            },
            updateConferenceConfiguration() {
                this.isSubmitted = true;
                if (!this.$v.data.$invalid) {
                    ConferenceService.updateConfiguration(this.retrieveData(), this.$store.state.activeUserId)
                        .then((response) => {
                            this.$toasted.global.starface_success({
                                message: 'Konferenzkonfiguration aktualisiert',
                                icon: 'CONFERENCE',
                            });
                            this.$router.push('/');
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Konferenzkonfiguration konnte nicht aktualisiert werden',
                                icon: 'CONFERENCE',
                            });
                        });
                } else {
                    this.$toasted.global.starface_error({
                        message: 'Bitte fülle alle Felder korrekt aus.',
                        icon: 'CONFERENCE',
                    });
                }
            },
            cancelUpdate() {
                this.router.push('/');
            }
            ,
            updateEmail(value) {
                if ('language' in value && value.language !== this.data.language) {
                    this.retrieveDefaultValue(value.language).then((response) => {
                        this.data = Object.assign({}, this.data, response);
                    });
                }
                if (this.data.language === USER_DEFINED_LANGUAGE && ('eMailBody' in value || 'eMailSubject' in value)) {
                    this.defaultValues.userDefined = Object.assign({}, this.defaultValues.userDefined, value);
                }
                this.data = Object.assign({}, this.data, value);
            },
            retrieveDefaultValue(language) {
                if (this.defaultValues[language]) {
                    return new Promise((resolve) => resolve(this.defaultValues[language]));
                }
                return ConferenceService.getDefaultConfiguration(language).then(result => {
                    this.defaultValues[language] = result.data;
                    return result.data;
                });

            },
        },
        computed: {
            cleanedVariables() {
                if (this.data.language !== USER_DEFINED_LANGUAGE) {
                    return this.variables;
                }
                return this.variables.filter(variable => this.variablesToRemove.indexOf(variable.placeholder) === -1);
            },
            cleanedEmailBody() {
                if (this.language !== USER_DEFINED_LANGUAGE) {
                    return this.data.eMailBody;
                }
                let body = this.data.eMailBody;
                for (const variable of this.variablesToRemove) {
                    body = body.replace(variable, '');
                }
                return body;
            },
        },
    };
</script>

<template>
    <div class="container">
        <div class="telephone-configuration">
            <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Konferenzdienst konfigurieren"/>
            <p>Jeder STARFACE UP-Nutzer kann mit der App spontane oder geplante Telefonkonferenzen starten.
                Um geplante Telefonkonferenzen durchführen zu können, musst Du diese einmalig hier einrichten.</p>
            <span class="external-number-title">Externe Rufnummer für Telefonkonferenzen:</span>
            <NumberPicker v-if="selectedNumber" :numbers="externalNumbers" :max-height="'210px'"
                          :columns="4" v-model="selectedNumber" :defaultValue="selectedNumber"/>
            <EmailConfiguration @update="updateEmail" :isSubmitted="isSubmitted" :eMailBody="cleanedEmailBody"
                                :eMailSubject="data.eMailSubject" :language="data.language"
                                :placeholders="cleanedVariables"/>
            <div class="buttons">
                <ButtonNormal @onClick="cancelUpdate" buttonTitle="Verwerfen" cssClass="btn btn-secondary"/>
                <ButtonNormal @onClick="updateConferenceConfiguration" buttonTitle="Änderungen speichern"
                              cssClass="btn btn-primary"/>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/buttons.scss';

    /deep/ .number-pick h1 {
        text-align: left;
        font-size: 18px;
    }

    .buttons {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: flex-end;
        margin-top: 30px;
    }

    .btn {
        margin-left: 30px;
        margin-bottom: 20px;
    }

    .external-number-title {
        color: $grey-dark;
        font-family: 'Open Sans', Arial, sans-serif;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
    }
</style>